import React from "react";
import Header from "../../components/VersatileComponents/Header";
import { Box, Grid, Button, useTheme } from "@mui/material";
import useCollectionData from "../../hooks/useCollectionData";
import UserCard from "../../components/User/card/callCenter/callCenter";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";

const CallCenter = () => {
  const { data: callcenters } = useCollectionData("callcenter");
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Call center</title>
        <meta name="description" content="List of call centers" />
      </Helmet>
      <Box
        m="1.5rem 2.5rem"
        sx={{
          backgroundColor: theme.palette.background.default,
          height: "100%",
          position: "relative",
        }}
      >
        <Header title="Call Center" subtitle="Entire list of Call Centers" />
        <Button
          variant="contained"
          color="primary"
          onClick={() => navigate("/callcenter/grading")}
          sx={{ mb: 2, mt: 4 }}
        >
          View Call Center Grading
        </Button>
        <Grid container spacing={2}>
          {callcenters.map((item) => (
            <Grid key={item.id} item xs={6} sm={4} md={4} lg={4} xl={4}>
              <UserCard userInfo={item} userType={"callcenter"} />
            </Grid>
          ))}
        </Grid>
      </Box>
    </>
  );
};

export default CallCenter;
